const LOGIN_STARTED = 'LOGIN_STARTED';
const LOGIN_COMPLETED = 'LOGIN_COMPLETED';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const RESET_VALUES = 'RESET_VALUES';

const login = (request, history, fromApp) => {
	return {
		type: LOGIN_STARTED,
		request,
		history,
		fromApp
	};
};

const resetValues = () => {
	return {
		type: RESET_VALUES,
	};
};

const loginCompleted = () => {
	return {
		type: LOGIN_COMPLETED,
	};
};

const loginSuccess = (details) => {
	return {
		type: LOGIN_SUCCESS,
		details,
	};
};

export default {
	types: {
		LOGIN_STARTED,
		LOGIN_COMPLETED,
		LOGIN_SUCCESS,
		RESET_VALUES,
	},
	creators: {
		login,
		loginCompleted,
		loginSuccess,
		resetValues,
	},
};
